<template>
	<!-- <navTitle><div class="pageTitle"></div></navTitle> -->
	<div class="content">
		<div class="classify">
			<div class="titleImg">
				<swiper ref="myHomeSwiper" class="home-swiper" :options="swiperOptions">
					<swiper-slide v-for="item in bannerList" :key="item.id" class="home-swiper-slide">
						<img class="titleImg" :src="item.image" alt="" />
					</swiper-slide>
				</swiper>
			</div>
			<div class="box flex flex-wrap flex-align-center flex-jus-between">
				<div @click="$router.push({'name': 'resources_video', query: {'name': item.name, 'id': item.id}})" class="item flex flex-column flex-align-center" v-for="item in majorList" :key="item.id">
					<div class="item-top">
						<img class="ring" src="@/static/images/my/ring.png">
						<img class="item-avatar" :src="item.image" alt="">
					</div>
					<div class="item-name">{{item.name}}</div>
				</div>
			</div>
		</div>
		<tabbar :tabbar="3"></tabbar>
	</div>
</template>

<script>
	/* eslint-disable */
	import {mapState} from 'vuex'
	export default {
		watch: {
		},
		data() {
			return{
				bannerList: [],
				swiperOptions: {
					autoplay: {
						delay: 3000 //3秒切换一次
					},
					pagination: {
						el: '.swiper-pagination'
					}
				},
			}
		},
		computed: {
			...mapState(['majorList'])
		},
		created() {
			this.getBanner()
		},
		mounted() {
			this.$wx.ready(() => {
				this.$wx.updateAppMessageShareData({
					title: '福建省民族管弦乐学会',
					desc: '乐堂',
					link: location.href,
					imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
				})
				this.$wx.updateTimelineShareData({
					title: '福建省民族管弦乐学会',
					link: location.href,
					imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
				})
			});
		},
		methods: {
			getBanner() {
				this.$get('api/common/getBanner', {
					type: 2
				}).then(res => {
					this.bannerList = res.data
				})
			}
		}
	}
</script>

<style scoped lang="stylus">
.content
	padding 24px 30px
.classify
	padding-bottom 80px
	.titleImg
		width 690px	
		height 222px
		margin-bottom 40px
		border-radius 24px
		overflow hidden
		img
			width 690px
			height 222px
			object-fit: cover;
	.box:after
		content ''
		display inline-block
		width 33.33%
	.item
		margin-bottom 40px
		width: 33.33%;
	.item-top
		width 152px
		height 152px
		position relative
		margin-bottom 16px
		.ring
			position absolute
			top 0
			left 0
			width 152px
			height 152px
		.item-avatar
			position absolute
			width 124px
			height 124px
			top 50%
			left 50%
			border-radius 50%
			transform translateX(-50%) translateY(-50%)
	.item-name
		font-size 26px
		line-height 36px
		color #000
</style>
